var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"clipFolderSkeleton"},[_c('v-skeleton-loader',{attrs:{"type":"card-avatar"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }